import { render, staticRenderFns } from "./ladderPrice.vue?vue&type=template&id=bb99fe8a&scoped=true"
import script from "./ladderPrice.vue?vue&type=script&lang=js"
export * from "./ladderPrice.vue?vue&type=script&lang=js"
import style0 from "./ladderPrice.vue?vue&type=style&index=0&id=bb99fe8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb99fe8a",
  null
  
)

export default component.exports